module.exports = __webpack_public_path__ + "img/partner_4.c96e9142.png";